/**
 * Paleta consistente para os charts. Cores tomadas das CSS vars do
 * design system. Como recharts usa SVG <path fill="...">, precisamos
 * de literais hex/rgb -- nao da pra passar ``var(--color-brand-500)``
 * direto em todos os contextos (Cell/Bar tem prop ``fill``). Por isso
 * espelhamos os valores aqui.
 *
 * Se a paleta mudar em ``globals.css``, atualizar tambem aqui (sem
 * automacao por enquanto -- a paleta e estavel).
 */

export const CHART_COLORS = {
  brand: "#d60852",
  accent: "#ffb800",
  success: "#16a34a",
  warning: "#f0a500",
  danger: "#dc2626",
  ink700: "#3d3c44",
  ink500: "#6c6b75",
  ink300: "#cfcdd6",
  line: "#ecebef",
} as const;

/**
 * Ciclo para charts categoricos (pizza, multi-series). Usado pelo
 * ``DonutChart`` e por barras quando precisamos colorir cada item
 * com cor diferente.
 */
export const CHART_PALETTE = [
  CHART_COLORS.brand,
  CHART_COLORS.accent,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.ink700,
  CHART_COLORS.danger,
] as const;

export function paletteAt(index: number): string {
  return CHART_PALETTE[index % CHART_PALETTE.length] ?? CHART_COLORS.brand;
}
